
import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../components/MeaButton";
import MeaDataTable from "../../../components/MeaDataTable";
import trainingsAPI from "../../../services/trainings";
import CreateTrainingModal from "./CreateTrainingModal";
import MeaLink from "../../../components/MeaLink";
import { PERMISSION_SCHOOL_TRAININGS } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useParams } from "react-router-dom";
import UpdateTrainingModal from "../info/components/UpdateTrainingModal";
import { Tag } from "primereact/tag";

const TrainingsListComponent = forwardRef((props, ref) => {
  const { showAddButton } = props;
  const { auth, currentMembership, hasPermission } = useAuthContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const params = useParams();
  const schoolId = params.schoolId
  const accessToken = "";
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  const [state, setState] = useUrlState({
    trainingName: "",
    trainingStatus: "",
  });
  const [training, setTraining] = useState(null);
  //
  const queryList = trainingsAPI.useGetList(
    schoolId,
    accessToken,
    page,
    pageSize,
    state.trainingStatus
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <MeaButton
          label="Créer une formation"
          icon="pi pi-plus"
          size="normal"
          className="p-button mr-2 action"
          onClick={() => {
            createModalRef.current.show(() => {
              queryList.refetch();
            });
          }}
          data-pr-tooltip="Nouvelle formation"
          permission={PERMISSION_SCHOOL_TRAININGS.CREATE}
        />
      )}
      {/* 
      <span className="p-input-icon-left mr-2 ">
        <i className="pi pi-search" />
        <InputText
          disabled
          className="p-inputtext-sm"
          value={state.memberName}
          onChange={(e) => setSearchName(e.target.value)}
          placeholder="Chercher une formation"
        />
      </span>
      */}
    </div>
  );
  //
  return (
    <>
      <CreateTrainingModal ref={createModalRef} schoolId={schoolId} accessToken={accessToken} />
      <MeaDataTable
        query={queryList}
        serviceAPI={trainingsAPI}
        schoolId={schoolId}
        accessToken={accessToken}
        names={{
          pagination: "trainings",
          singular: "formation",
          plural: "formations",
        }}
        startToolbarTemplate={startToolbarTemplate}
        showDeleteButton={hasPermission(PERMISSION_SCHOOL_TRAININGS.DELETE)}
        //showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
        rowClassName={(rowData) => {
          if (rowData.status === "OPEN") {
            return 'bg-green-100';
          } else if (rowData.status === "DRAFT") {
            return 'bg-blue-100';
          } else if (rowData.status === "SUSPENDED") {
            return 'bg-red-100';
          } else if (rowData.status === "ARCHIVED") {
            return 'bg-gray-100';
          } else {
            return '';
          }
        }}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column
          field="status"
          header="Statut"
          body={(item) => {
            return item?.status ? (
              <Tag
                value={item.status === "OPEN"
                  ? "Ouvert"
                  : item.status === "DRAFT"
                    ? "Brouillon"
                    : item.status === "SUSPENDED"
                      ? "Suspendu"
                      : item.status === "ARCHIVED"
                        ? "Archivé"
                        : item.status}
                severity={
                  item.status === "OPEN"
                    ? "success"
                    : item.status === "DRAFT"
                      ? "info"
                      : item.status === "SUSPENDED"
                        ? "warning"
                        : item.status === "ARCHIVED"
                          ? "contrast"
                          : null
                }
              />
            ) : (
              "-"
            );
          }}
        ></Column>
        <Column
          field="name"
          header="Formation"
          body={(item) => (
            <MeaLink to={"/school/" + schoolId + "/admin/trainings/" + item.id + "/info"} permission={PERMISSION_SCHOOL_TRAININGS.GET}>
              {item.name}
            </MeaLink>
          )}
        ></Column>
        <Column field="presentation" header="Présentation"></Column>

        <Column
          field="start_courses_date"
          header="Date de début des cours"
          body={(item) => {
            return item?.start_courses_date ? new Date(item?.start_courses_date).toLocaleDateString("fr-FR") : "-";
          }}
        ></Column>
        <Column
          field="end_courses_date"
          header="Date de fin des cours"
          body={(item) => {
            return item?.end_courses_date ? new Date(item?.end_courses_date).toLocaleDateString("fr-FR") : "-";
          }}
        ></Column>

        <Column
          body={(item) => (
            <>
              <MeaButton
                icon="pi pi-pencil"
                rounded
                text
                aria-label="Filter"
                style={{ padding: "0", height: "1.5rem" }}
                onClick={() => {
                  setTraining(item);
                  if (updateModalRef.current) {
                    updateModalRef.current.show(() => {
                      queryList.refetch();
                    });
                  }
                }}
                permission={PERMISSION_SCHOOL_TRAININGS.UPDATE}
              />
            </>
          )}
          headerStyle={{ width: "10%", minWidth: "8rem" }}
          bodyStyle={{ textAlign: "center" }}
        ></Column>
      </MeaDataTable>
      <UpdateTrainingModal ref={updateModalRef} schoolId={schoolId} training={training} query={queryList} accessToken={accessToken} />
    </>
  );
});

export default TrainingsListComponent;
